import { useState } from "react";
import { connect } from "react-redux";
import { RESET_CHAT_SESSION } from "redux/chat";
import trackEvent from "utils/trackEvent";
import ConfirmActionModal from "components/ConfirmActionModal";
import TrashIcon from "images/trash.svg";

// Reset always confirms first, then only actually clears the visible thread
// once the server call in RESET_CHAT_SESSION succeeds (see redux/chat.js -
// the rejected case deliberately leaves messages/sessionId untouched).
const ResetSessionButton = ({ resetSession, status }) => {
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleConfirm = () => {
    setConfirmOpen(false);
    trackEvent("CHAT_RESET_SESSION");
    resetSession();
  };

  return (
    <>
      <button
        type="button"
        className="chat-reset-btn"
        disabled={status === "loading"}
        title="Reset working session"
        aria-label="Reset working session"
        onClick={() => setConfirmOpen(true)}>
        <img src={TrashIcon} alt="" className="chat-reset-icon" />
        <span className="chat-reset-label">Reset session</span>
      </button>
      <ConfirmActionModal
        isOpen={confirmOpen}
        title="Reset working session?"
        message="This clears your current chat thread on the server. This can't be undone."
        confirmLabel="Reset"
        cancelLabel="Keep chatting"
        onConfirm={handleConfirm}
        onCancel={() => setConfirmOpen(false)}
      />
    </>
  );
};

export default connect(
  ({ chat: { status } }) => ({ status }),
  dispatch => ({
    resetSession: () => dispatch(RESET_CHAT_SESSION()),
  })
)(ResetSessionButton);
